import AssessmentItemComponent from '@app/components/assessments/assessmentItem/AssessmentItem'
import { ItemsNavigator } from '@app/components/common/ItemsNavigator'
import { TestPart } from '@app/models'
import { trackAssessmentItemViewEvent } from '@app/services/eventChain'
import { CurrentTestState, moveToSelectedItem, ScoringState } from '@app/storage'
import { Box, styled } from '@mui/material'
import { FC, useEffect, useRef } from 'react'
import { useSearchParams } from 'react-router-dom'
import { useSnapshot } from 'valtio'

interface TestPartProps {
  testPart: TestPart
}

const TestPartComponent: FC<TestPartProps> = ({ testPart }) => {
  const { itemsResponses, currentItemResponse, testPartItems } = useSnapshot(CurrentTestState)
  const { groupMode } = useSnapshot(ScoringState)
  const [searchParams] = useSearchParams()
  const lastTrackedItemId = useRef<string | null>(null)

  useEffect(() => {
    const itemId = currentItemResponse.itemId

    if (!groupMode || !itemId) {
      lastTrackedItemId.current = itemId ?? null
      return
    }

    if (lastTrackedItemId.current === null) {
      lastTrackedItemId.current = itemId
      return
    }

    if (lastTrackedItemId.current === itemId) {
      return
    }

    lastTrackedItemId.current = itemId
    trackAssessmentItemViewEvent({
      itemId,
      contentId: searchParams.get('contentId'),
      courseCategory: searchParams.get('courseCategory'),
      districtId: searchParams.get('districtId'),
      organizationId: searchParams.get('organizationId'),
      classId: searchParams.get('classId'),
      schoolId: searchParams.get('schoolId'),
      teacherId: searchParams.get('teacherId'),
      origin: searchParams.get('origin'),
      preview: searchParams.get('preview')?.toLowerCase() === 'true',
      questionPreviewId: searchParams.get('questionPreviewId') || null,
    })
  }, [currentItemResponse.itemId, groupMode, searchParams])

  return (
    <>
      {itemsResponses.length > 0 && currentItemResponse.id && testPartItems.length && (
        <>
          <AssessmentItemComponent />
          <TestFooterWrapper>
            <ItemsNavigator onChange={moveToSelectedItem} />
          </TestFooterWrapper>
        </>
      )}
    </>
  )
}

export const TestFooterWrapper = styled(Box)(({ theme }) => ({
  position: 'relative',
  padding: theme.spacing(4, 8),
  backgroundColor: theme.palette.common.white,
  boxShadow: theme.shadows[6],

  [theme.breakpoints.down('mobile')]: {
    padding: theme.spacing(0),
  },
}))

export default TestPartComponent
